import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../api";
import { Icon } from "../lib/Icon";
import { ErrorNote, Loading, Page } from "./common";

const CARD: React.CSSProperties = { background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", padding: "14px 18px" };

export function Flows() {
  const qc = useQueryClient();
  const { data, isLoading, error } = useQuery({ queryKey: ["flows"], queryFn: api.flows });
  const create = useMutation({
    mutationFn: (name: string) => api.createFlow(name),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["flows"] }),
  });
  const toggle = useMutation({
    mutationFn: (id: string) => api.toggleFlow(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["flows"] }),
  });
  if (isLoading) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  const flows = data ?? [];
  return (
    <Page>
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between" }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>Chat flows</h1>
          <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>Pre-chat question trees the widget runs before a ticket reaches a rep.</div>
        </div>
        <button
          onClick={() => { const n = window.prompt("Name this chat flow"); if (n && n.trim()) create.mutate(n.trim()); }}
          disabled={create.isPending}
          style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12.5, fontWeight: 600, color: "#fff", background: "#006747", border: 0, borderRadius: 7, padding: "8px 12px", cursor: "pointer" }}
        >
          <Icon name="plus" size={14} color="#fff" /> New flow
        </button>
      </div>

      {(create.isError || toggle.isError) && (
        <div style={{ ...CARD, background: "#fbe9e7", boxShadow: "inset 0 0 0 1px #f3d3ce", color: "#b3261e", fontSize: 12.5 }}>
          {(() => { const e = create.error ?? toggle.error; return `Action failed — ${e instanceof Error ? e.message : String(e)}`; })()}
        </div>
      )}

      {flows.length === 0 ? (
        <div style={{ ...CARD, color: "#8a8e88", fontSize: 13 }}>No chat flows yet. Create one to route pre-chat questions to the right mailbox, tier and tags.</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 12 }}>
          {flows.map((f) => (
            <div key={f.id} style={CARD}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                <span style={{ fontSize: 14, fontWeight: 600 }}>{f.name}</span>
                <button
                  onClick={() => toggle.mutate(f.id)}
                  title={f.active ? "Active — click to pause" : "Paused — click to activate"}
                  style={{ fontSize: 10.5, fontWeight: 600, padding: "2px 8px", borderRadius: 999, border: 0, cursor: "pointer", background: f.active ? "#e8f4ee" : "#f0efe9", color: f.active ? "#1f8a5b" : "#6b706a" }}
                >
                  {f.active ? "active" : "paused"}
                </button>
              </div>
              <div style={{ fontSize: 11.5, color: "#8a8e88", marginTop: 6 }}>
                {f.stepCount} step{f.stepCount === 1 ? "" : "s"}{f.mlsId ? ` · ${f.mlsId}` : " · all clients"}
              </div>
            </div>
          ))}
        </div>
      )}
    </Page>
  );
}
